module.exports = __webpack_public_path__ + "img/biaoqian_jianchazhan.e7ba96fa.png";